import { useMutation } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import { Dossier } from "../../types/Dossier";

type SetPrimaryQuotePayload = {
  quoteId: string;
};

export const setPrimaryQuote = (
  dossierId: string,
  options: APQueryOptions = {}
) => {
  const { fetchWithAuth } = useApi();
  const {
    defaultOnMutateError,
    defaultOnMutateSuccess,
    defaultOnMutateSettled,
    optimisiticUpdateOnMutate,
    getDataByQueryKey,
  } = useAPQuery();

  return useMutation({
    mutationFn: (payload: SetPrimaryQuotePayload): Promise<boolean> => {
      return fetchWithAuth<boolean>("setPrimaryQuote", dossierId, {
        requestOptions: { method: "post", body: JSON.stringify(payload) },
      });
    },
    onMutate: async (payload) => {
      const queryKey = ["dossier", dossierId];
      const dossier = getDataByQueryKey(queryKey) as Dossier;
      const updatedOpportunity = dossier.opportunity
        ? { ...dossier.opportunity, primaryQuoteId: payload.quoteId }
        : undefined;
      const updatedDossier: Dossier = {
        ...dossier,
        opportunity: updatedOpportunity,
      };

      optimisiticUpdateOnMutate(["dossier", dossierId], updatedDossier);
    },
    onError: defaultOnMutateError(options),
    onSuccess: defaultOnMutateSuccess(options),
    onSettled: () => defaultOnMutateSettled([["dossiers"]]),
  });
};
